import React, { useCallback, useMemo } from 'react';
import { useField } from 'react-final-form';
import { observer } from 'mobx-react';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';
import { TextAreaField } from 'ksnm-common-ui/lib/Form/TextAreaField';
import { createMask } from 'ksnm-common-ui/lib/MaskedInput';
import { maxBy } from 'lodash-es';

import { filterOperatorsStore } from '@stores/dictionaryStores/filterOperatorsStore';
import { indicatorEditStore } from '@stores/dictionaryStores/indicatorsStore/indicatorEditStore';
import type { ReportGroupsDto, VarFilterDto } from '@src/api';

const renderName = (value: ReportGroupsDto) => `${value.code} - ${value.name}`;

export const Form = observer(({ filters, sourceField }: { filters: VarFilterDto[]; sourceField: string }) => {
  const { isEditMode, sourceFields } = indicatorEditStore;
  const { filterOperators } = filterOperatorsStore;

  const {
    input: { value: id },
  } = useField('id');

  const {
    input: { value: orGroup },
  } = useField('orGroup');

  const {
    input: { onChange: changeAndGroup },
  } = useField('andGroup');

  const maxOrGroup = useMemo(() => Number(maxBy(filters, 'orGroup')?.orGroup ?? 0) + 1, [filters]);

  const maxAndGroup = useMemo(() => {
    const filtered = filters.filter((item) => +(item.orGroup ?? -1) === +orGroup);
    const max = maxBy(filtered, 'andGroup')?.andGroup ?? 0;

    return +max + 1;
  }, [orGroup, filters]);

  const sourceFieldsItems = useMemo(() => {
    const table = sourceField.split('.')?.[0];
    return table ? sourceFields.filter((item) => item.id.split('.')[0] === table) : [];
  }, [sourceField, sourceFields]);

  const orGroupMask = useMemo(() => createMask('NUMBER'), []);
  const andGroupMask = useMemo(() => createMask('NUMBER'), []);

  const onChange = useCallback(() => {
    changeAndGroup(undefined);
  }, [changeAndGroup]);

  return (
    <>
      <TextField
        name="orGroup"
        label="Номер правила"
        disabled={!isEditMode || id}
        size="small"
        groupStyle={!isEditMode}
        required
        min={1}
        max={maxOrGroup}
        mask={orGroupMask}
        onChange={onChange}
        placeholder={`Введите значение от 1 до ${maxOrGroup}`}
      />
      <TextField
        name="andGroup"
        label="Последовательность условий в правиле"
        disabled={!isEditMode || id}
        size="small"
        groupStyle={!isEditMode}
        required
        min={1}
        max={maxAndGroup}
        mask={andGroupMask}
        placeholder={`Введите значение от 1 до ${maxAndGroup}`}
      />
      <SelectField
        items={sourceFieldsItems}
        name="fieldName"
        label="Фильтр: Имя поля"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        required
      />
      <SelectField
        items={filterOperators}
        name="selOption"
        label="Фильтр: Опция"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        renderName={renderName}
        required
      />
      <TextAreaField
        name="fieldValue"
        label="Фильтр: Значение"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        maxLength={255}
        autoSize
      />
    </>
  );
});
